import { Component } from "react";
import moment from "moment";
import "moment-timezone";
import { Authority, ErrorX, store } from "static";
import { DOMAIN } from "config/config";
import axios from "axios";
import _ from "lodash";
import { StarterDashboardHook } from "./StarterDashboardHook";

export interface StarterDashboardState {
  data: {
    DailyConv: { name: string; count: number }[];
    Overview: { title: string; values: number; remarks?: string }[];
    CustomerBehavior: { title: string; values: string | number; remarks?: string }[];
    Feedback: {
      docQueryDistribution: { name: string; value: number }[];
      likeDistribution: { name: string; value: number }[];
    };
    Performance: {
      intentDistribution: { name: string; value: number }[];
    };
  };
  base: {
    title: string;
    schema?: any; // not used
    titles: {
      Usage: string;
      Performance: string;
      CutomerBehaviour: string;
      Feedback: string;
    };
    graphTitles: {
      DailyCov: string;
      DocQueryDistribution: string;
      LikeDistribution: string;
      IntentDistribution: string;
    };
    url: Record<string, string>;
  };
  dateRange: {
    from: moment.Moment;
    to: moment.Moment;
  };
}

export class StarterDashboard extends Component<{}, StarterDashboardState> {
  constructor(props: {}) {
    super(props);

    this.state = {
      data: {
        DailyConv: [],
        Overview: [],
        CustomerBehavior: [],
        Feedback: {
          docQueryDistribution: [],
          likeDistribution: [],
        },
        Performance: {
          intentDistribution: [],
        },
      },
      base: {
        title: "",
        titles: {
          Usage: "USAGE OVERVIEW",
          Performance: "PERFORMANCE",
          CutomerBehaviour: "CUSTOMER BEHAVIOUR",
          Feedback: "FEEDBACK",
        },
        graphTitles: {
          DailyCov: "DAILY CONVERSATION",
          DocQueryDistribution: "DOCUMENTS QUERIED",
          LikeDistribution: "USER FEEDBACK",
          IntentDistribution: "Top 10 FAQ DISTRIBUTION",
        },
        url: {
          Info: "/Data/Analytics/StarterDashboard",
        },
      },
      dateRange: {
        from: moment().startOf("month"),
        to: moment(),
      },
    };
  }

  componentDidMount() {
    Authority.Require("StarterDashboard");
    this.fetchData();
  }

  onChangeDateRange(dates: [moment.Moment | null, moment.Moment | null] | null, _formatString?: [string, string]) {
    if (!dates || !dates[0] || !dates[1]) {
      throw new Error("Dates cannot be null");
    }
    this.setState(
      {
        dateRange: { from: moment(dates[0]).startOf("day"), to: moment(dates[1]).endOf("day") },
      },
      () => {
        this.fetchData();
      }
    );
  }

  async fetchData(): Promise<void> {
    const { base, dateRange } = this.state;
    const url = `${DOMAIN}${base.url.Info}`;
    const payload = {
      JWT: store.user.JWT,
      DateRange: dateRange,
      timezone: moment.tz.guess(),
    };
    const { data } = await axios.post<{ Success: boolean; payload: StarterDashboardState["data"] }>(url, payload);

    if (data.Success) {
      this.setState({ data: data.payload });
    } else {
      ErrorX.Handle(data as any);
    }
  }

  render(): React.ReactNode {
    const { base, dateRange, data } = this.state;
    return <StarterDashboardHook base={base} data={data} dateRange={dateRange} onChangeDateRange={this.onChangeDateRange.bind(this)} fetchData={this.fetchData} />;
  }
}

export default StarterDashboard;
